// eslint-disable-next-line consistent-return
const getInitialFrom = (data, defaultGateway, previousSessionValue) => {
	if (!previousSessionValue) {
		return defaultGateway;
	}

	if (data?.length > 0) {
		const previousSessionGateway = data?.find(
			gateway =>
				gateway?.code?.toUpperCase() ===
				previousSessionValue?.value?.toUpperCase()
		);

		return {
			label:
				`${previousSessionGateway?.name} (${previousSessionGateway?.code})` ??
				defaultGateway?.label,
			value: previousSessionGateway?.code ?? defaultGateway?.value
		};
	}
};

export default getInitialFrom;
